import { useConferenceInstance, IConference } from '@containers/Conference';
import { Record } from '@screens/ConferenceSession';

export function RecordingStatus() {
  const instance = useConferenceInstance<IConference.Coordinator.Conference.MeetingRoom>();

  return <Record visible={instance.conference.record} />;
}